import React from "react";
import { localize } from "redux-i18n";
import { connect } from "react-redux";
import { compose } from "redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, View } from "@components";
import { RTWInterviewForm } from "@modules/reporting/components";
import actionCreators from "@modules/reporting/actionCreator";
import type { SelectedTask } from "@modules/reporting/reducer/tasks/types";
import { getSelectedTask } from "@modules/reporting/selectors/tasks";

type OwnProps = $Exact<{
  onClose: () => void,
  clientId: number,
  rtwInterviewId: number,
}>;

type PropsFromState = $Exact<{
  selectedTask: SelectedTask,
}>;

type PropsFromDispatch = $Exact<{
  selectRtwTask: typeof actionCreators.GetRtwInterviewTask,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export class AbsenceRateTrendRTWInterviewModal extends React.Component<Props> {
  componentDidMount() {
    if (!this.props.selectedTask) {
      this.props.selectRtwTask({
        clientId: this.props.clientId,
        taskId: this.props.rtwInterviewId,
      });
    }
  }

  render() {
    return (
      <Modal className="modal-large">
        <ModalHeader tag="h3" toggle={this.props.onClose}>
          {this.props.t("RTW_INTERVIEW")}
        </ModalHeader>
        <ModalBody>
          {this.props.selectedTask && (
            <RTWInterviewForm
              clientId={this.props.clientId}
              printForm={false}
              visible={true}
              onSubmit={this.props.onClose}
            />
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onClose}>
            {this.props.t("CANCEL")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => ({
  selectedTask: getSelectedTask(state),
});

const mapDispatchToProps: PropsFromDispatch = {
  selectRtwTask: actionCreators.GetRtwInterviewTask,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(AbsenceRateTrendRTWInterviewModal);
